import React from "react";
import userStyles from "../Styles/ViewOfUsersPages.module.css";

const AboutTeam = () => (
	<div
		className={userStyles.viewOfUsersContainer}
		style={{ minHeight: "100vh", background: "var(--page-background)" }}
	>
		<div className={userStyles.tableWrapper}>
			<h2 className={userStyles.pageTitle}>About the Team</h2>
			<p>
				Global Medic Force's MD-Sensei Platform (MD-S) represents the digitization of a 25-year humanitarian legacy. It captures the collective field deployment expertise of +2,000 elite physicians and +30,000 years of clinical service - deployed into +42 developing countries over 4 continents. This represents a reservoir of real-world clinical capital valued at over $8 billion.
			</p>

			<p>
				Developed by elite volunteer medical experts from Global Medic Force (GMF), MD-S is an advanced AI-driven solution acting as a Digital Clinical Mentor to deliver concise, situationally relevant, real-life clinical guidance to Healthcare Workers in the developing world, at point-of-care, in real-time, and on-demand.  MD-S empowers Healthcare Workers to provide the best care possible within their existing resource limitations no matter how remote, inaccessible, hostile, contested, non-permissive and demanding the local conditions.  
			</p>

			<p>
				MD-S bridges the gap between Western medical excellence and the "front lines" of global health throughout the developing world.
			</p>			
		</div>
	</div>
);

export default AboutTeam;
